/**
 * Leitura dos textos de `data/currentRelease.js` para o popup de Novidades.
 *
 * O conteúdo é escrito à mão em cada lançamento ("Comandas 🧾", descrição
 * com "📍 Menu → Tela" no fim). Estas funções tiram daí o que a tela desenha
 * em separado: o emoji vira o medalhão do cartão, o caminho vira o chip
 * "Onde fica", e o item em texto simples (correções) vira uma linha.
 */

// Emoji no fim do título, com variação (️) e sequências unidas (‍).
const EMOJI_FINAL = /\s*((?:\p{Extended_Pictographic}|\p{Emoji_Presentation})(?:️|‍(?:\p{Extended_Pictographic}|\p{Emoji_Presentation}))*)$/u;
const EMOJI_INICIAL = /^((?:\p{Extended_Pictographic}|\p{Emoji_Presentation})(?:️|‍(?:\p{Extended_Pictographic}|\p{Emoji_Presentation}))*)\s*/u;
const CAMINHO = /\n*📍\s*([^\n]+)\s*$/u;

/** "Comandas 🧾" -> { texto: "Comandas", emoji: "🧾" }; sem emoji -> emoji "". */
export function separarEmojiFinal(titulo) {
  const t = String(titulo || "").trim();
  const m = t.match(EMOJI_FINAL);
  if (!m) return { texto: t, emoji: "" };
  return { texto: t.slice(0, m.index).trim(), emoji: m[1] };
}

/** "🚀 Novidades" -> { texto: "Novidades", emoji: "🚀" } (título da seção/aba). */
export function separarEmojiInicial(titulo) {
  const t = String(titulo || "").trim();
  const m = t.match(EMOJI_INICIAL);
  if (!m) return { texto: t, emoji: "" };
  return { texto: t.slice(m[0].length).trim(), emoji: m[1] };
}

/** Descrição com "📍 Menu → Tela" no fim -> { corpo, caminho }. */
export function separarCaminho(desc) {
  const d = String(desc || "");
  const m = d.match(CAMINHO);
  if (!m) return { corpo: d.trim(), caminho: "" };
  return { corpo: d.slice(0, m.index).trim(), caminho: m[1].trim() };
}

/**
 * Item de seção (string ou { title, desc }) -> forma única para o cartão:
 * { titulo, emoji, corpo, caminho, simples }. `simples` = era texto puro.
 */
export function normalizarItem(item) {
  if (item && typeof item === "object") {
    const { texto, emoji } = separarEmojiFinal(item.title);
    const { corpo, caminho } = separarCaminho(item.desc);
    return { titulo: texto, emoji, corpo, caminho, simples: false };
  }
  return { titulo: "", emoji: "", corpo: String(item || "").trim(), caminho: "", simples: true };
}
